module.exports = require("./az-Cyrl.d.ts");